import React from "react"
import autobind from "class-autobind"
import { Dialog, TextField, FlatButton } from "material-ui"
import strings from "../../localization/strings"
import Clear from "../misc/Clear"
import Table from "../common/Table"
import { TableBody, TableHeader, TableHeaderColumn, TableRow, TableRowColumn } from "material-ui"
import { IPayrollItemForAccountLevel, IHierarchyItem } from "../../models"
import * as payrollHelper from "../../helpers/payrollHelper"

interface IProps {
  selectedPayrollHierarchyIds: string[]
  handleClose(): void
  handleSelect(selectedPayrollHierarchyIds: string[]): void
}
interface IState {
  selectedPayrollHierarchyIds: string[]
  search: string
}

export default class ChoosePayrollHierarchyDialogForChip extends React.Component<IProps, IState> {
  private payrollHierarchyItems: (IPayrollItemForAccountLevel | IHierarchyItem)[]
  constructor(props) {
    super(props)
    this.payrollHierarchyItems = payrollHelper.getSelectablePayrollHierarchyItems()
    this.state = {
      search: "",
      selectedPayrollHierarchyIds: []
    }
    autobind(this)
  }

  render() {
    const filteredPayrollHierarchyItems = this.payrollHierarchyItems
      .filter(i => !this.props.selectedPayrollHierarchyIds.includes(i.Id))
      .filter(i => this.state.search ?
        i.Label.toLowerCase().includes(this.state.search.toLowerCase()) :
        true
      )
    return (
      <Dialog
        open
        modal
        autoScrollBodyContent
        title={strings.Select_Payroll_Hierarchy}
        actions={[
          <FlatButton
            data-intercom-target={"Btn-Close-PayrollHierarchy-Selection-Dialog"}
            label={strings.Cancel}
            secondary
            onClick={this.props.handleClose}
          />,
          <FlatButton
            data-intercom-target={"Btn-Save-Selected-PayrollHierarchy"}
            label={strings.OK}
            primary
            disabled={this.state.selectedPayrollHierarchyIds.length > 0 ? false : true}
            onClick={() => this.props.handleSelect(this.state.selectedPayrollHierarchyIds)}
          />
        ]}
        onRequestClose={this.props.handleClose}
      >
        <div data-intercom-target={"Supervisor-Selection-Dialog"}>
          <div style={{ padding: 20, paddingLeft: 35 }}>
            <i style={{ fontSize: 25 }} className="fa fa-search" />
            <TextField
              style={{ marginRight: 20, width: "90%", marginLeft: 15 }}
              hintText={strings.search}
              value={this.state.search}
              onChange={e => this.setState({ search: e.target.value })}
            />
            <Clear />
          </div>
          <div style={{ textAlign: "center", height: 500 }}>
            <Table
              items={filteredPayrollHierarchyItems}
              handleSelect={selectedPayrollHierarchyItems => this.setState({ selectedPayrollHierarchyIds: selectedPayrollHierarchyItems.map(i => i.Id) })}
            >
              <TableHeader>
                <TableRow>
                  <TableHeaderColumn>{strings.Name}</TableHeaderColumn>
                  <TableHeaderColumn>{strings.External_ID}</TableHeaderColumn>
                  <TableHeaderColumn>{strings.CostCenter}</TableHeaderColumn>
                </TableRow>
              </TableHeader>
              <TableBody showRowHover={true} deselectOnClickaway={false}>
                {filteredPayrollHierarchyItems.map((row, i) =>
                  <TableRow key={row.Id} selected={this.state.selectedPayrollHierarchyIds.includes(row.Id)}>
                    <TableRowColumn>
                      {row.Label}
                    </TableRowColumn>
                    <TableRowColumn>{(row as IHierarchyItem).ExternalId}</TableRowColumn>
                    <TableRowColumn>{(row as IHierarchyItem).CostCenter}</TableRowColumn>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </div>
        </div>
      </Dialog>
    )
  }
}
